import { gql } from 'graphql-tag';

export const getUserFeatureAttributes = gql`
    query getUserFeatureAttributes {
        getUserFeatureAttributes {
            description
            platform
            featureSetting
            featureKey
        }
    }
`;
